import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetorajsthancab() {



  const cardData =
  {
    keyword: 'Pune to Rajasthan cab   ',
    heading: 'Sai Trupti Cabs: Pune to Rajasthan cab ',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Rajasthan cab service for long-distance and multi-day tour travel, covering popular destinations like Jaipur, Udaipur, Jodhpur, and Jaisalmer. Our fleet includes well-maintained AC sedans, SUVs, Innova Crysta, and premium vehicles, all equipped with clean interiors and ample luggage space for extended journeys. Every trip is handled by a professional, background-verified driver ensuring timely pickup in Pune, safe driving, and a smooth travel experience across Rajasthan. We provide flexible options like one way cab Pune to Rajasthan, round trip taxi, and customized Rajasthan tour packages at transparent and affordable pricing with no hidden charges. With 24x7 online booking, instant confirmation, and dedicated customer support, Sai Trupti Cabs ensures your Rajasthan trip is comfortable, safe, and completely hassle-free.',

    top: 'Top Places to Visit in Rajasthan with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Amber Fort, Jaipur",
    "description": "Amber Fort is a majestic hilltop fort located in Jaipur, blending Rajput and Mughal architecture. Built in the 16th century by Raja Man Singh, the fort features grand courtyards, intricate mirror work, ornate gates, and beautiful palaces. Visitors can explore the Sheesh Mahal (Mirror Palace), Ganesh Pol, and enjoy elephant rides up the hill. Amber Fort offers panoramic views of Maota Lake and the surrounding Aravalli hills. Its rich history, royal ambiance, and stunning architecture make it an unmissable attraction in Rajasthan."
  },
  {
    "title": "City Palace, Jaipur",
    "description": "The City Palace in Jaipur is a sprawling royal complex that combines Mughal and Rajput styles. Built in the 18th century by Maharaja Sawai Jai Singh II, it houses the Chandra Mahal, Mubarak Mahal, courtyards, gardens, and museums displaying royal artifacts, costumes, and weapons. Visitors can explore its grandeur while witnessing the legacy of Jaipur’s royal family. The palace’s blend of history, art, and architecture reflects the grandeur of Rajasthan’s regal past."
  },
  {
    "title": "Hawa Mahal, Jaipur",
    "description": "Hawa Mahal, the ‘Palace of Winds,’ is a striking five-story pink sandstone structure with 953 small windows, allowing cool breezes to circulate while providing royal women privacy. Built in 1799 by Maharaja Sawai Pratap Singh, it is an iconic symbol of Jaipur. Visitors can explore its narrow corridors and balconies, capturing breathtaking views of the city. The intricate lattice work and unique design make Hawa Mahal a must-see monument showcasing Rajasthan’s architectural ingenuity."
  },
  {
    "title": "Mehrangarh Fort, Jodhpur",
    "description": "Mehrangarh Fort is a massive 15th-century fortress overlooking Jodhpur, known for its imposing walls and magnificent architecture. The fort houses palaces with intricate carvings, expansive courtyards, and a museum displaying royal artifacts, armory, and paintings. Visitors can enjoy panoramic views of the ‘Blue City’ from its ramparts. Mehrangarh Fort is a symbol of Marwar’s power, heritage, and architectural brilliance, attracting history enthusiasts and photographers alike."
  },
  {
    "title": "Umaid Bhawan Palace, Jodhpur",
    "description": "Umaid Bhawan Palace is one of the world’s largest private residences, built in the 20th century by Maharaja Umaid Singh. A part of the palace functions as a luxury hotel while another section serves as a museum displaying royal memorabilia. The grand architecture, lush gardens, and art deco interiors make it a unique blend of history and modern luxury. Visiting Umaid Bhawan offers a glimpse into the regal lifestyle of Jodhpur’s royalty."
  },
  {
    "title": "City Palace, Udaipur",
    "description": "The City Palace in Udaipur is a magnificent complex overlooking Lake Pichola, built over nearly 400 years by the Mewar dynasty. It features a series of palaces, courtyards, gardens, and museums with royal artifacts. The intricate balconies, towers, and marble inlays showcase Rajput architectural excellence. Visitors can enjoy stunning lake views and explore the rich history of Mewar kings. The palace stands as a symbol of Rajasthan’s elegance, art, and heritage."
  },
  {
    "title": "Lake Pichola, Udaipur",
    "description": "Lake Pichola is a serene man-made lake in Udaipur, surrounded by palaces, temples, and ghats. Boating on the lake provides stunning views of the City Palace, Jag Mandir, and Lake Palace. Especially at sunset, the reflections of the palaces on the water create a magical ambiance. Lake Pichola offers a peaceful escape and a romantic setting, showcasing Udaipur’s charm as the ‘City of Lakes.’"
  },
  {
    "title": "Jaisalmer Fort",
    "description": "Jaisalmer Fort, also known as Sonar Quila (Golden Fort), rises from the desert with golden sandstone walls shimmering in sunlight. Built in the 12th century by Rawal Jaisal, it houses palaces, temples, havelis, and bustling markets within its walls. The fort is still inhabited, giving visitors a living glimpse into Rajasthan’s heritage. Its strategic location and intricate carvings make it one of India’s most fascinating desert forts."
  },
  {
    "title": "Sam Sand Dunes, Jaisalmer",
    "description": "The Sam Sand Dunes offer an unforgettable desert experience near Jaisalmer. Visitors can enjoy camel safaris, cultural performances, desert camping, and stunning sunset views over the golden sands. The dunes are especially vibrant during the cooler winter months. Experiencing the desert life, traditional music, and local cuisine makes Sam Sand Dunes a quintessential Rajasthani adventure."
  },
  {
    "title": "Chittorgarh Fort",
    "description": "Chittorgarh Fort is the largest fort in India and a symbol of Rajput valor, sacrifice, and architectural brilliance. Built in the 7th century, the fort sprawls across hills with massive gates, palaces, temples, and towers. It is associated with legends of Rani Padmini and heroic tales of the Mewar dynasty. The fort offers panoramic views, ancient structures, and a sense of timeless history. Chittorgarh Fort embodies the courage and resilience of Rajasthan’s warriors."
  }
],



   "services": [
    {
      "name": "Pune to Jodhpur Cab",
      "description": "Reliable cab service from Pune to Jodhpur offering AC/non-AC vehicles, professional drivers, luggage support, and flexible pickup/drop points. Perfect for long-distance travel, sightseeing, and cultural tours of Rajasthan, ensuring a comfortable and safe journey."
    },
    {
      "name": "Pune to Jaipur Cab",
      "description": "Comfortable cab service from Pune to Jaipur with multiple vehicle options including Sedan, SUV, Innova, and luxury cars. Features experienced drivers, AC/non-AC options, luggage assistance, flexible schedules, and real-time tracking for a seamless Rajasthan trip."
    },
    {
      "name": "Pune to Udaipur Cab",
      "description": "Outstation cab service from Pune to Udaipur offering AC/non-AC cars, professional drivers, luggage support, and scenic route travel. Ideal for tourists, family trips, and couples exploring the City of Lakes."
    },
    {
      "name": "Pune to Jaisalmer Tour Package",
      "description": "Comprehensive Jaisalmer tour package from Pune including AC/non-AC cab, professional driver, guided sightseeing, desert safari, and 3-4 days itinerary options. Perfect for family trips, honeymoon tours, and cultural experiences in Rajasthan."
    },
    {
      "name": "Jaisalmer Tour Package for 3 Days",
      "description": "3-day, 2-night Jaisalmer tour package featuring comfortable cab travel from Pune, guided city tours, desert safari, local attractions, hotel stay options, and professional drivers for a memorable desert experience."
    },
    {
      "name": "Jaisalmer Tour Package for 4 Days",
      "description": "4-day Jaisalmer tour package with Pune pickup, AC cab travel, sightseeing of forts, havelis, desert safaris, cultural experiences, and professional drivers. Ideal for family trips or long weekend Rajasthan tours."
    },
    {
      "name": "Pune to Khatu Shyam Tour Package",
      "description": "Cab and tour package from Pune to Khatu Shyam offering comfortable AC/non-AC vehicles, professional driver, temple visit arrangements, luggage support, and flexible itineraries. Suitable for religious trips and pilgrimage tours."
    },
    {
      "name": "Pune to Khatu Shyam Cab Booking",
      "description": "Book cab from Pune to Khatu Shyam with AC/non-AC vehicles, experienced drivers, luggage assistance, and real-time tracking. Perfect for a hassle-free religious journey."
    },
    {
      "name": "Pune to Bikaner Cab Booking",
      "description": "Direct cab service from Pune to Bikaner with multiple vehicle options including Sedan, SUV, and Innova. Offers AC/non-AC comfort, professional drivers, luggage support, and transparent fares for long-distance travel."
    },
    {
      "name": "Pune to Bikaner Tour Package",
      "description": "Outstation cab and tour package from Pune to Bikaner including sightseeing, AC/non-AC cab, professional drivers, luggage assistance, and customized itineraries for 2-4 days. Ideal for family trips and cultural experiences."
    },
    {
      "name": "Pune to Rajasthan Cab Booking",
      "description": "Book cabs from Pune to Rajasthan cities including Jaipur, Jodhpur, Udaipur, Jaisalmer, Bikaner, Ajmer, and Pushkar. Offers AC/non-AC vehicles, experienced drivers, luggage support, flexible pickup/drop locations, and real-time tracking."
    },
    {
      "name": "Pune to Rajasthan Taxi Booking Online",
      "description": "Convenient online taxi booking service from Pune to any Rajasthan destination. Multiple vehicle options, transparent pricing, professional drivers, AC/non-AC comfort, luggage support, and flexible schedules ensure a stress-free road trip."
    },
    {
      "name": "Pune to Rajasthan Cab Fare",
      "description": "Transparent and competitive cab fares from Pune to Rajasthan based on vehicle type, distance, and one-way/round-trip travel. Includes tolls, driver allowance, and luggage support for a hassle-free journey."
    },
    {
      "name": "Pune to Rajasthan Taxi Fare",
      "description": "Affordable taxi service from Pune to Rajasthan cities with AC/non-AC vehicles, professional drivers, and transparent pricing for solo travelers, families, and corporate trips."
    },
    {
      "name": "Pune to Rajasthan Cab Price",
      "description": "Cab pricing from Pune to Rajasthan depends on distance, vehicle type, AC/non-AC preference, and travel schedule. Includes clear fare breakdown with no hidden charges."
    },
    {
      "name": "Pune to Rajasthan Taxi Charges",
      "description": "Charges for Pune to Rajasthan taxi service are transparent and depend on vehicle category, distance, tolls, and driver allowance. Ideal for long-distance road trips and family travel."
    },
    {
      "name": "Best Pune to Rajasthan Cab Service",
      "description": "Top-rated Pune to Rajasthan cab service providing AC/non-AC Sedans, SUVs, Innova, and luxury vehicles, professional drivers, luggage support, flexible pickup/drop points, and real-time tracking for a safe and comfortable journey."
    },
    {
      "name": "Cheap Pune to Rajasthan Cab",
      "description": "Budget-friendly cab options from Pune to Rajasthan including AC/non-AC Sedans, Ertiga, and SUV taxis. Offers professional drivers, luggage assistance, and safe highway travel at economical rates."
    },
    {
      "name": "Pune to Rajasthan One Way Cab",
      "description": "Convenient one-way cab service from Pune to Rajasthan destinations with multiple vehicle options, AC/non-AC comfort, experienced drivers, luggage support, and transparent pricing for a seamless journey."
    },
    {
      "name": "Pune to Rajasthan Round Trip Taxi",
      "description": "Round-trip taxi service from Pune to Rajasthan including AC/non-AC vehicles, professional drivers, luggage assistance, real-time tracking, and flexible itineraries for family trips, business travel, and sightseeing tours."
    },
    {
      "name": "Pune to Rajasthan Innova Cab",
      "description": "Spacious Innova cab service from Pune to Rajasthan offering comfort, AC travel, ample luggage space, professional drivers, and safe long-distance travel suitable for families and groups."
    },
    {
      "name": "Pune to Rajasthan Innova Crysta Cab",
      "description": "Luxury Innova Crysta cab from Pune to Rajasthan with premium interiors, AC comfort, smooth highway travel, professional drivers, luggage assistance, and transparent fares for a stress-free journey."
    },
    {
      "name": "Pune to Rajasthan Ertiga Cab",
      "description": "Economical Ertiga cab from Pune to Rajasthan ideal for small families and group travel. Offers AC/non-AC options, luggage support, experienced drivers, and comfortable long-distance travel."
    },
    {
      "name": "Pune to Rajasthan Sedan Cab",
      "description": "Sedan cab service from Pune to Rajasthan offering smooth and comfortable rides for solo travelers and couples. Features AC/non-AC vehicles, luggage support, and professional drivers."
    },
    {
      "name": "Pune to Rajasthan SUV Taxi",
      "description": "SUV taxi from Pune to Rajasthan offering better space, safety, and highway comfort. Includes AC/non-AC options, luggage support, and professional drivers for family and corporate travel."
    },
    {
      "name": "Pune to Rajasthan AC Cab",
      "description": "Air-conditioned cab service from Pune to Rajasthan with comfortable seating, professional drivers, luggage assistance, and point-to-point travel for long-distance journeys."
    },
    {
      "name": "Pune to Rajasthan Luxury Cab",
      "description": "Premium luxury cab from Pune to Rajasthan offering top-class vehicles, AC comfort, professional chauffeurs, luggage support, flexible schedules, and real-time tracking for VIP travelers."
    },
    {
      "name": "Pune to Pushkar Cab",
      "description": "Cab service from Pune to Pushkar for pilgrimage or leisure travel. Features AC/non-AC vehicles, professional drivers, luggage support, and flexible pickup/drop points for comfortable long-distance travel."
    },
    {
      "name": "Pune to Pushkar Taxi",
      "description": "Taxi service from Pune to Pushkar with AC/non-AC vehicle options, experienced drivers, luggage assistance, and safe highway travel for family, group, or solo travelers."
    },
    {
      "name": "Pune to Rajasthan Tour Cab",
      "description": "Full-service tour cab from Pune to Rajasthan covering cities like Jaipur, Jodhpur, Udaipur, Jaisalmer, Ajmer, Bikaner, and Pushkar. Includes AC/non-AC vehicles, professional drivers, luggage support, and customized itineraries."
    },
    {
      "name": "Pune to Rajasthan Family Trip Cab",
      "description": "Family-friendly cab service from Pune to Rajasthan offering AC/non-AC vehicles, comfortable seating, professional drivers, luggage support, and flexible routes for sightseeing and pilgrimage trips."
    },
    {
      "name": "Pune to Rajasthan Sightseeing Taxi",
      "description": "Rajasthan sightseeing taxi service from Pune providing AC/non-AC vehicles, professional drivers, flexible itineraries, and luggage assistance for visiting forts, palaces, desert safaris, and cultural attractions."
    },
    {
      "name": "Pune to Rajasthan Desert Safari Cab",
      "description": "Specialized cab service for desert safari trips in Rajasthan from Pune. Includes AC/non-AC vehicles, experienced drivers, luggage support, and guided itinerary for Jaisalmer and Thar Desert exploration."
    },
    {
      "name": "Pune to Rajasthan Pilgrimage Cab",
      "description": "Pilgrimage-focused cab service from Pune to Rajasthan temples and holy sites. Offers AC/non-AC vehicles, professional drivers, luggage support, flexible pickup/drop points, and comfortable long-distance travel."
    },
    {
      "name": "Pune to Ajmer Sharif Cab",
      "description": "Direct cab service from Pune to Ajmer Sharif Dargah with AC/non-AC options, professional drivers, luggage assistance, and transparent fares for a comfortable religious trip."
    },
    {
      "name": "Pune to Rajasthan Cab Fare per KM",
      "description": "Detailed fare calculation per kilometer for Pune to Rajasthan cab trips based on vehicle type, distance, AC/non-AC preference, and travel schedule. Includes tolls and driver allowances."
    },
    {
      "name": "One-Way vs Round-Trip Rajasthan Taxi Cost",
      "description": "Comparison of costs between one-way and round-trip cab services from Pune to Rajasthan. Includes vehicle types, AC/non-AC options, driver allowances, tolls, and distance-based pricing for informed travel planning."
    },
    {
      "name": "Best Car for Pune to Rajasthan Road Trip",
      "description": "Recommended vehicle options for Pune to Rajasthan road trips including Sedan, SUV, Innova, and Innova Crysta based on group size, luggage, comfort, and highway travel for safe and enjoyable long-distance journeys."
    },
    {
      "name": "Pune to Ajmer Cabs",
      "description": "Direct cab service from Pune to Ajmer offering AC/non-AC vehicles, professional drivers, luggage assistance, and flexible pickup/drop points for business, leisure, and pilgrimage travel."
    },
    {
      "name": "Pune to Kota Cab",
      "description": "Reliable outstation cab service from Pune to Kota with AC/non-AC vehicles, experienced drivers, luggage support, and comfortable highway travel. Suitable for business trips, student travel, and family excursions."
    },
    {
      "name": "Pune to Bhilwara Cabs",
      "description": "Cab service from Pune to Bhilwara providing AC/non-AC vehicles, professional drivers, luggage assistance, and safe long-distance travel. Ideal for family trips, business travel, and cultural sightseeing."
    }
  ],
  "tableData": [
    ["Pune to Jodhpur Cab", "Pune to Jaipur Cab"],
    ["Pune to Udaipur Cab", "Pune to Jaisalmer Tour Package"],
    ["Jaisalmer Tour Package for 3 Days", "Jaisalmer Tour Package for 4 Days"],
    ["Pune to Khatu Shyam Tour Package", "Pune to Khatu Shyam Cab Booking"],
    ["Pune to Bikaner Cab Booking", "Pune to Bikaner Tour Package"],
    ["Pune to Rajasthan Cab Booking", "Pune to Rajasthan Taxi Booking Online"],
    ["Pune to Rajasthan Cab Fare", "Pune to Rajasthan Taxi Fare"],
    ["Pune to Rajasthan Cab Price", "Pune to Rajasthan Taxi Charges"],
    ["Best Pune to Rajasthan Cab Service", "Cheap Pune to Rajasthan Cab"],
    ["Pune to Rajasthan One Way Cab", "Pune to Rajasthan Round Trip Taxi"],
    ["Pune to Rajasthan Innova Cab", "Pune to Rajasthan Innova Crysta Cab"],
    ["Pune to Rajasthan Ertiga Cab", "Pune to Rajasthan Sedan Cab"],
    ["Pune to Rajasthan SUV Taxi", "Pune to Rajasthan AC Cab"],
    ["Pune to Rajasthan Luxury Cab", "Pune to Pushkar Cab"],
    ["Pune to Pushkar Taxi", "Pune to Rajasthan Tour Cab"],
    ["Pune to Rajasthan Family Trip Cab", "Pune to Rajasthan Sightseeing Taxi"],
    ["Pune to Rajasthan Desert Safari Cab", "Pune to Rajasthan Pilgrimage Cab"],
    ["Pune to Ajmer Sharif Cab", "Pune to Rajasthan Cab Fare per KM"],
    ["One-Way vs Round-Trip Rajasthan Taxi Cost", "Best Car for Pune to Rajasthan Road Trip"],
    ["Pune to Ajmer Cabs", "Pune to Kota Cab"],
    ["Pune to Bhilwara Cabs", ""]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Pune to Rajasthan Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs offers reliable and comfortable cab services from Pune to Rajasthan — perfect for leisure trips, sightseeing tours, family travel, and group journeys."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our one-way fares from Pune to Rajasthan start from approximately ₹10,000–₹15,000 for sedans, with SUVs and premium cars available at competitive rates depending on distance and vehicle type."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, tempo travellers, or premium cars to suit your group size, luggage requirements, and comfort preferences for your Pune → Rajasthan trip."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are experienced in long-distance travel from Pune to Rajasthan, ensuring a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups anywhere in Pune and drop-offs at your Rajasthan destination, hotels, or tourist spots."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly serviced, sanitized, and equipped with essential amenities for a comfortable and hygienic long-distance journey."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings, route planning, or travel assistance for your Pune to Rajasthan cab trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Rajasthan cab easily through a call, WhatsApp, or our website — with instant confirmation and quick vehicle dispatch."
  }
]



  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Pune to Rajasthan cab services?',
    answer: 'Yes, Sai Trupti Cabs provides reliable and affordable cab services from Pune to Rajasthan for one-way, round-trip, and group travel.',
  },
  {
    question: 'How can I book a Pune to Rajasthan cab with Sai Trupti Cabs?',
    answer: 'You can book your Pune to Rajasthan cab through our website, mobile app, WhatsApp, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Pune to Rajasthan?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, tempo travellers, and luxury cabs for Pune to Rajasthan travel.',
  },
  {
    question: 'Are the drivers experienced for Pune to Rajasthan trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance interstate travel.',
  },
  {
    question: 'Can I hire a cab from Pune to Rajasthan for multi-city tours?',
    answer: 'Yes, we provide flexible cab services for multi-city Rajasthan tours, sightseeing trips, and family travel.',
  },
  {
    question: 'Is the Pune to Rajasthan cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services for Pune to Rajasthan trips.',
  },
  {
    question: 'What are the Pune to Rajasthan cab fares?',
    answer: 'Our fares start from approximately ₹10,000 for sedans and ₹15,000–₹25,000 for SUVs and premium vehicles, depending on distance and travel requirements.',
  },
  {
    question: 'What payment options are accepted for Pune to Rajasthan cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Rajasthan cabs?',
    answer: 'All vehicles are sanitized before every trip, and drivers follow strict hygiene and safety measures.',
  },
  {
    question: 'Is customer support available during the Pune to Rajasthan cab ride?',
    answer: 'Yes, our 24×7 customer support team is available throughout your Pune to Rajasthan cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Sharma',
    feedback: 'Booked a Pune to Rajasthan cab. Comfortable ride and the driver was very experienced for long-distance interstate travel.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Pooja Verma',
    feedback: 'Excellent Pune to Rajasthan cab service. Polite driver, clean vehicle, and hassle-free booking.',
    rating: 5,
  },
];


















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Rajasthan Cab Tour Package",
  "image": "https://saitrupticabs.com/assets/images/pune-to-rajasthan-cab.jpg",
  "description": "Sai Trupti Cabs offers Pune to Rajasthan cab service for multi-day tour packages including Jaipur, Udaipur, Jodhpur and Jaisalmer. Book Innova Crysta, Ertiga, sedan and SUV cabs for long distance outstation travel with professional drivers, 24x7 service and affordable pricing.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "10860"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "14999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-rajasthan-cab",
    "itemCondition": "https://schema.org/NewCondition"
  }
};






  return (
    <div>

<Helmet>
  <title>Pune to Rajasthan Cab | Tour Package ₹14999 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Pune to Rajasthan cab tour package at ₹14999 with Sai Trupti Cabs. Visit Jaipur, Udaipur, Jodhpur & Jaisalmer with Innova Crysta, Ertiga, sedan & SUV. Safe and comfortable long-distance travel." 
  />

  <meta 
    name="keywords" 
    content="pune to rajasthan cab, pune to jaipur cab, pune to udaipur cab, pune to jodhpur taxi, pune to rajasthan tour package, rajasthan cab package from pune, pune to rajasthan one way cab, pune to rajasthan round trip cab, innova crysta rajasthan tour pune, cheap rajasthan cab pune, best cab service rajasthan tour, rajasthan outstation cab booking pune" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/94.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetorajsthancab;